import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Unit } from '@models/unit.model';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private isInitialized = false;

  init(): void {
    if (this.isInitialized || !environment.gaId) {
      return;
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', environment.gaId, {
      send_page_view: false,
    });
    window.gtag('user_properties', environment.gaId, {
      instance_uuid: environment.instanceUuid,
    });

    this.isInitialized = true;
  }

  pageView(path: string): void {
    if (!this.isInitialized) {
      return;
    }

    this.trackEvent('page_view', {
      page_path: path
    });
  }

  trackImpression(unit: Unit) {
    if (!this.isInitialized) {
      return;
    }

    this.trackEvent('impression', {
      instance_uuid: environment.instanceUuid,
      building_id: unit.buildingPropertyId,
      property_id: unit.propertyId,
    });
  }

  trackLead(unit: Unit) {
    if (!this.isInitialized) {
      return;
    }

    this.trackEvent('lead', {
      instance_uuid: environment.instanceUuid,
      building_id: unit.buildingPropertyId,
      property_id: unit.propertyId,
    });
  }

  trackEvent(name: string, params: Record<string, any> = {}): void {
    if (!this.isInitialized) {
      return;
    }

    window.gtag('event', name, params);
  }
}
